<script setup>
const fullWidthMode = inject("fullWidthMode", false);
const halfCol = computed(() => (fullWidthMode ? undefined : 6));
import {
  splitSentencesByDivider,
  splitKeywordParts,
  splitBySentence,
} from '@/composables/splitSentence';
import { useAnalysisDataStore } from '@/store/modules/analysisDataStore';
import SurveyCard from '@/components/calendar/drawer/pages/cards/SurveyCard.vue';
import { addContentLogAPI } from '@/api/logServiceApi';

const emit = defineEmits(['goToOverView', 'postRate']);

const props = defineProps({
  yData: Object,
  ratingResult: Number,
  ratingStatus: Boolean,
});

const goToOverView = () => {
  addContentLogAPI('ay_yongsin_btn_restart');
  emit('goToOverView');
};

const postRate = (score) => {
  emit('postRate', score);
};
</script>

<template>
  <VRow class="full-height">
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-first">
      <VCard class="personality-card full-height right">
        <div class="personality-wrapper outro content_info_area_box">
          <div class="yongsin-outro">
            <div class="yongsin-outro__box">
              <div class="nangmane-img" />
              <div class="yongsin-outro__text">
                <div class="yongsin-outro__tit">낭만 용신분석</div>
                <div class="yongsin-outro__desc">
                  우리는 사주를 통해 나를 이해하고,<br />
                  용신을 통해 균형을 배우며,<br />
                  그 위에서 스스로의 길을 만들어갑니다.<br />
                  <br />
                  용신이라는 개념을 활용하여<br />
                  더 지혜로울 수 있는 선택의 길을<br />
                  조화롭게 펼쳐가시길 바랍니다<br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
    <VCol cols="12" :md="halfCol" class="no-pad-col mobile-second">
      <VCard class="personality-card full-height">
        <div class="personality-wrapper outro content_info_area_box">
          <div class="rating-personality">
            <SurveyCard
              style="width: 100%"
              :ratingResult="ratingResult"
              :ratingStatus="ratingStatus"
              @postRate="postRate"
            />
            <div class="personality-replay">
              <button class="replay-btn content_review_button_restart" @click="goToOverView()">
                <i class="return-icon"></i>
                다시보기
              </button>
            </div>
          </div>
        </div>
      </VCard>
    </VCol>
  </VRow>
</template>
<style scoped lang="scss">
@import '@/assets/nangman_style/_util.scss';
@import '@/assets/nangman_style/youngsin.scss';
</style>
